import React from 'react';
import {NextSeo} from 'next-seo';
import NewsTNHNavDetails from '@components/NewsTNHDetails/NewsTNHNavDetails';
import NewsTNHDetails from '@components/NewsTNHDetails/NewsTNHDetails';
import { BookingProvider } from '@contexts/BookingContext';

export default function NewsDetailsPages(props) {
    const {seoPage} = props;
    
    return (
        <BookingProvider>
            {seoPage && <NextSeo {...seoPage} />}
            <div>
                <NewsTNHNavDetails news={props.preloadedNews} />
                <NewsTNHDetails {...props} />
            </div>
        </BookingProvider>
    );
}
